import { Numeric5BoxOutlineIcon } from './Numeric5BoxOutlineIcon';

/**
 * author: Google
 * id 38CB37B2-2BF9-4890-8060-5576DDAE6FC6
 * name numeric-5-box-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/numeric-5-box-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const Number5BoxOutlineIcon = Numeric5BoxOutlineIcon;
export default Number5BoxOutlineIcon